import script from "./NewLandingPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLandingPageView.vue?vue&type=script&setup=true&lang=js"

import "./NewLandingPageView.vue?vue&type=style&index=0&id=38441a16&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38441a16"]])

export default __exports__